
import { reactive } from "vue";
import DynamicForm from "@/components/Shared/Dynamicform/DynamicForm.vue";

export default {
  name: "UserPrivacy",
  inheritAttrs: false,
  components: {
    DynamicForm
  },
  setup() {    
    const request = reactive({
      apiLoadMethod: "",
      apiSaveMethod: "api/Form/saveForm",
      form: "Benutzer",
      page: "BenutzerDatenschutz",
      remoteId: "",
      waitForResponse: true
      
    });

    return {
      request
    };
  }
};
